import {bp} from '../core/namespace.js';

let shareModalOpen = false;

$.extend(true, bp, {
  share: (function () {
    return {
      init: function () {
        const shareDialog = document.querySelector('.share-dialog');

        $(document).on('click', '.share-button', function (e) {
          e.preventDefault();
          e.stopPropagation();
          try {
            recordShareCount();
          } catch (error) {
            console.log(error);
          }

          window.scrollTo(0, 0);
          if (navigator.canShare) {
            navigator.share({
              title: 'Bedrijfspand',
              text: $(this).data('share-text'),
            })
              .then(() => console.log('Share was successful.'))
              .catch((error) => console.log('Sharing failed', error));
            return false;
          } else {
            shareDialog.classList.add('is-open');
            shareModalOpen = true;
          }
        });

        $(document).on('click', 'body', (event) => {
          if (shareModalOpen === false) {
            return;
          }
          if (event.target.classList.contains('sd_event')) {
            return;
          }
          shareDialog.classList.remove('is-open');
        });

        $(document).on('click', '.close-button', () => {
          shareDialog.classList.remove('is-open');
          shareModalOpen = false;
        });
      },
      copyToClipboard: function (element) {
        var $temp = $('<input>');
        $('body').append($temp);
        $temp.val($(element).text()).select();
        document.execCommand('copy');
        $temp.remove();
      },
      shareAPI: function (e, url) {
        if (navigator.canShare && navigator.canShare({files: filesArray})) {
          e.preventDefault();
          navigator.share({
            title: 'Bedrijfspand',
            text: url,
          })
            .then(() => console.log('Share was successful.'))
            .catch((error) => console.log('Sharing failed', error));
          return false;
        }
        return true;
      },
    };
  })(),
});

window.bp_share = {dialog: bp.share};

export {bp};
